import { useState } from 'react';
import useUpdate from '../../../../hooks/useUpdate';
import Swal from 'sweetalert2';

const ChangeEmailForm = () => {
  const [newEmail, setNewEmail] = useState('');
  const [password, setPassword] = useState('');

  const {
    updateData,
    errorMessage,
    successMessage,
    isLoading
  } = useUpdate('put');

    const handleEmailChange = async (e) => {
        e.preventDefault();


        const result = await Swal.fire({
            title: 'Are you sure ?',
            text: 'Do you want to proceed ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: 'btn-info',
            cancelButtonColor: 'btn-secondary',
            confirmButtonText: 'Yes, proceed!',
            cancelButtonText: 'No, cancel',
            confirmButtonColor: '#03c3ec',
            cancelButtonColor: '#ff3e1d',
        });

        if (result.isConfirmed) {
            try {
                updateData(`${process.env.REACT_APP_API_URL}/request-email-change/`, {
                    new_email: newEmail,
                    password: password
                });
            } catch (error) {
                console.error("Error inserting data:", error);
            }
        } else if (result.dismiss === Swal.DismissReason.cancel) {
            console.log('Submission cancelled.');
        }
    };

  return (
    <div className="card mb-4">
      <div className="card-header">
        <h5>Change Email</h5>
        <p className="text-muted">A verification email will be sent to your new address.</p>
      </div>
      <div className="card-body">
        <form onSubmit={handleEmailChange}>
          <div className="mb-3">
            <label className="form-label">New Email</label>
            <input
              type="email"
              className="form-control"
              value={newEmail}
              onChange={(e) => setNewEmail(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Confirm Password</label>
            <input
              type="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary" disabled={isLoading}>
            {isLoading ? 'Sending...' : 'Send Verification Email'}
          </button>

          {errorMessage && <div className="text-danger mt-3">{errorMessage}</div>}
          {successMessage && <div className="text-success mt-3">{successMessage}</div>}
        </form>
      </div>
    </div>
  );
};

export default ChangeEmailForm;
